var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.config)?_c('login-personalize-preview',{attrs:{"initial-config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }